<template>
    <b-form-group
            class="c-instance-selector"
            :description="description"
            :label="label"
            :label-for="id"
            :key="'instance_' + id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
                <label v-if="!Core.Validation.isEmpty(dataValue.id)">
                    {{dataValue.label}}
                </label>
                <label v-if="Core.Validation.isEmpty(dataValue.id)">
                    <small class="text-muted font-italic">{{emptyMessage}}</small>
                </label>
                <b-link v-if="!Core.Validation.isEmpty(dataValue.id)"  @click="onResetClick"  href="#" class="card-header-action btn-setting mt-2">
                    {{Core.Definition.getDefinition('Réinitialiser')}}
                </b-link>
                <b-link v-if="Core.Validation.isEmpty(dataValue.id)" @click="onSelectClick" href="#" class="card-header-action btn-setting mt-2">
                    {{Core.Definition.getDefinition('Sélectionner')}}
                </b-link>

                <ModalInstanceSelector
                        ref="modalInstanceSelector"
                        :id="'instanceSelector_' + id"
                        :key="'instanceSelector_' + id"
                        :root="instanceSelector.root"
                        :searchFormStructure="instanceSelector.searchFormStructure"
                        :searchArgs="searchArgs"
                        :multiple="false"
                        v-model="dataValues"
                        :options="instanceSelector.options"
                        :columns="Core.Array.newArray(instanceSelector.columns)"></ModalInstanceSelector>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import ModalInstanceSelector from './ModalInstanceSelector'
  export default {
      name: 'InputInstanceSelector',
      components: {
          ModalInstanceSelector,
      },
      props: {
          required: {
              type: Boolean,
              default: false
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          emptyMessage: {
              type: String,
              default: '',
              required: true
          },
          form: {
              type: Object,
              default: function () {
                  return {}
              }
          },
          fieldRefs: {
              type: Array,
              default: function () {
                  return []
              }
          },
          value: {
              type: Object,
              default: function () {
                  return {
                      id: '',
                      label: ''
                  }
              }
          },
          instanceSelector: {
              type: Object,
              default: function () {
                  return {
                      root: '',
                      searchFormStructure: {},
                      data: {},
                      options: {
                          pagination: true,
                          header: true,
                          responsive: false,
                          striped: true,
                          headerStyle: '1',
                          emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                          borderVariant: 'white',
                          noBody: true
                      },
                      columns: [],
                      label: '',
                      id: ''
                  }
              },
              required: true
          },
          searchArgs: {
              type: Array,
              default: function () {
                  return []
              }
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          },
          dataValues: {
              handler(val) {
                  let value = {
                      id: '',
                      label: ''
                  }
                  if (val[0] !== undefined && val[0].instance !== undefined) {
                      if (this.instanceSelector.id !== undefined) {
                          let ids = []
                          if (Array.isArray(this.instanceSelector.id)) {
                              for(let id in this.instanceSelector.id) {
                                  id = this.instanceSelector.id[id]
                                  if (undefined !== val[0].instance[id]) {
                                      ids.push(val[0].instance[id])
                                  }
                              }
                              value.id = ids.join(',')
                          } else {
                              if (undefined !== val[0].instance[this.instanceSelector.id]) {
                                  value.id = val[0].instance[this.instanceSelector.id]
                              }
                          }

                          let labels = []
                          if (Array.isArray(this.instanceSelector.label)) {
                              for(let label in this.instanceSelector.label) {
                                  label = this.instanceSelector.label[label]
                                  if (undefined !== val[0].instance[label]) {
                                      labels.push(val[0].instance[label])
                                  }
                              }
                              value.label = labels.join(' ')
                          } else {
                              if (undefined !== val[0].instance[this.instanceSelector.label]) {
                                  value.label = val[0].instance[this.instanceSelector.label]
                              }
                          }
                      }
                  }
                  this.dataValue = Core.Array.newObject(value)
              }
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              Core: window.Core,
              dataId: '',
              dataValue: {
                  id: '',
                  label: ''
              },
              dataValues: []
          }
      },
      methods: {
          onSelectClick() {
              this.$refs.modalInstanceSelector.open = true
          },
          onResetClick() {
              this.dataValue = {
                  id: '',
                  label: ''
              }
          }
      }
  }
</script>